<template>
  <div v-if="logged" id="emolumentos" class="d-flex align-items-center justify-content-center">
    <div>
      <b-card class="mb-2">
        <h3 class="card-title blue">Atenção!</h3>
        <b-card-text>
          Para emissão de certidão, haverá cobrança de emolumentos.
          <br/>Deseja continuar com a solicitação?
        </b-card-text>

        <div class="row mt-4">
            <div class="col-lg-6 d-flex">
              <b-button @click="aceitar(false)" variant="outline-secondary" class="btn-lg" block>Cancelar</b-button>
            </div>
            <div class="col-lg-6 d-flex justify-content-md-end">
              <b-button @click="aceitar(true)" variant="primary" class="btn-lg" block>Continuar</b-button>
            </div>
        </div>
        
      </b-card>
    </div>
    <vue-recaptcha
        ref="invisibleRecaptcha"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
        :sitekey="sitekey"
        :loadRecaptchaScript="true">
    </vue-recaptcha>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
export default {
  components: {
    VueRecaptcha
  },
  methods: {
    aceitar(aceito) {
      this.aceito = aceito
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function (response) {
      //console.log(response)
      this.$refs.invisibleRecaptcha.reset()
      this.resetRecaptcha()
      
      let name = this.aceito ? 'certidao' : 'consulta'
      let documento = localStorage.getItem("documento")
      this.$router.push(
          {
            name: name, 
            params: {
              documento: documento,
              solicitarCertidao: this.aceito,
              token_captcha:response
            }
          }
        )
    },
    onExpired: function () {
      this.$refs.invisibleRecaptcha.reset()
    },
     resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    },
  },
  data() {
    return {
      logged: false,
       sitekey: process.env.VUE_APP_sitekeyRecaptchaInvisivelV2,
       aceito:''
    }
  },
  mounted() {
    this.$root.isLogged().then(() => this.logged = true).catch(() => this.logged = false)
  } 
}
</script>

<style scoped>
#emolumentos {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
  background-color: var(--main-bg-cinza);
}
</style>

